<template>
  <div class="bodyBox">
    <!--创建方案  -->
    <!-- <div class="titelSpan">基础促销</div>
    <div class="menu-center">
      <div class="item" v-for="item,index in base" :key="index">
        <div class="top">
          <div style="display: flex">
            <img :src="require('../../assets/' + item.src)" style="width: 40px" />
            <span style="color: black; font-size: 16px; margin-left: 16px"
              >{{item.title}}</span
            >
          </div>
          <p>
            <span>{{item.top}}</span>
          </p>
          <p>
            <span>{{item.bottom}}</span>
          </p>
        </div>
        <div @click="$router.push(item.link)" class="bottom" style="color: #666">
          <span class="bottom-text">创建 +</span>
        </div>
      </div>
    </div> -->
    <!--场景促销  -->
    <div class="titelSpan">场景促销</div>
    <div class="menu-center">
      <div class="item" v-for="item,index in others" :key="index">
        <div class="top">
          <div style="display: flex">
            <img :src="require('../../assets/' + item.src)" style="width: 40px" />
            <span style="color: black; font-size: 16px; margin-left: 16px"
              >{{item.title}}</span
            >
            <!-- <el-tooltip effect="dark" content="" placement="top">
                  <template slot="content">
                    <div style="height: 63px;width: 234px;line-height: 1.5;font-size: 14px;">对订单进行整体折扣
例：整单8折</div>
                  </template>
                  <img src="../../assets/images/问号.svg" style="width: 17px;height: 24px;">
    </el-tooltip> -->
          </div>
          <p><span>{{item.top}}</span></p>
          <p><span>{{item.bottom}}</span></p>
        </div>
        <div class="bottom" style="color: #666" @click="$router.push(item.link)">
          <span class="bottom-text">创建 +</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            base:[
             {link:'/allDiscountCreate',src:'images/base1.svg',title:'整单折扣',top:'对订单进行整体折扣',bottom:'例：整单8折'},
           {link:"/categoryCreate",src:'images/base2.svg',title:'分类折扣',top:'对不同分类设置不同折扣',bottom:'例：菜品8折，酒水不打折'},
          {link:"/dishDiscount",src:'images/base3.svg',title:'菜品折扣',top:'对指定菜品设置折扣',bottom:'例：土豆丝5折'},
          {link:"/allDiscountCreate",src:'images/base4.svg',title:'特价菜',top:'给指定菜品设置特价',bottom:'例：周一凉菜类立减10元'},
            ],
            others:[
 {src:'images/other1.svg',title:'第N份优惠',top:'提升客单的优惠活动,常用于情侣消费,朋友消费',bottom:'例：饮品第二杯半价',link:'/nactivityCreate'},
 {src:'images/other2.svg',title:'买赠',top:'指定菜品，买X赠送Y',bottom:'例：可乐买2赠1',link:'/giveActiveCreate'},
  {src:'images/other3.svg',title:'买免',top:'买多份菜品，免其中一份',bottom:'例：买2免1',link:'/buyFreeCreate'},
  {src:'images/other4.svg',title:'菜品加价购',top:'购买指定份数的活动菜品，加x元即可换购加价购菜品',bottom:'例：买薯条加3元可换购一杯可乐',link:'additionBuy'},
  {link:'/packageDiscountCreate',src:'images/other5.svg',title:'满量折扣',top:'购买指定份数以上的活动菜品，活动菜品可享指定折扣',bottom:'例：购买3瓶以上酒水，3瓶酒水打8折'},
   {src:'images/other6.svg',title:'满量减免',top:'购买指定份数的活动菜品，活动菜品共减X元',bottom:'例：购买3瓶饮料，3瓶饮料共减10元',link:'/fullReduction'},
  {link:'/packageSpecial',src:'images/other7.svg',title:'满量一口价',top:'购买指定份数的活动菜品，活动菜品一口价共X元',bottom:'例：购买3个热菜，共50元'},
  {link:'/fullSpecial',src:'images/other8.svg',title:'满量菜品特价',top:'买满指定数量，享受特惠单价',bottom:'例：购买月饼满50盒，享受88元/盒，购买第51盒也是88元'},
   {link:'/fullReduce',src:'images/other9.svg',title:'满减',top:'消费满指定金额菜品，即可得到减价优惠',bottom:'例：消费金额满100减10元'},
  {link:'/fullFree',src:'images/other10.svg',title:'满赠',top:'消费满指定金额，即赠送指定菜品',bottom:'例：满100元可赠送可乐1瓶'},
  {link:'/fullAddition',src:'images/other11.svg',title:'满额加价购',top:'消费满指定金额菜品，加X元即可换购菜品',bottom:'例：消费满100元加5元可换购可乐'},
  {link:'/fullDiscount',src:'images/other12.svg',title:'满折',top:'消费满指定金额，可享受折扣',bottom:'例：满500元可打8折'},
   {link:'/fullGoodsReduce',src:'images/other13.svg',title:'满额优惠购',top:'消费满指定金额，再购买指定菜品享优惠',bottom:'例：买满20元板栗，再买烤红薯减5元'},
            ]
        }
    }
};
</script>

<style lang="less" scoped>
.titelSpan {
  z-index: 3;
  width: fit-content;
  position: relative;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 32px;
}
.titelSpan::after {
  position: absolute;
  display: inline-block;
  content: "";
  bottom: -4px;
  left: 0px;
  z-index: -1;
  width: 100%;
  background: rgb(255, 189, 0);
  height: 8px;
  transform: translateY(-50%);
}
.bodyBox {
  padding: 24px;
  background-color: #fff;
  .menu-center {
    display: flex;
    // padding: 20px 0px;
    flex-wrap: wrap;
    .item:nth-child(3n) {
      margin-right: 0;
    }

    .item {
      height: 187px;
      width: calc((100% - 48px) / 3);
      box-sizing: border-box;
      margin-right: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #e8e8e8;
      margin-top: 16px;
      .top {
        padding-left: 24px;
        padding-top: 24px;
        p {
          transform: translateY(-10px);
          margin-bottom: 0;
          margin-left: 56px;
          margin-top: 0;
          padding-right: 24px;
          span {
            color: rgb(153, 153, 153);
            font-size: 14px;
          }
        }
        span {
          font-size: 12px;
          color: #ccc;
        }
      }
      .bottom {
        height: 46px;
        background-color: #fafafa;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        border: 1px solid #e8e8e8;
        transition: 1s;
      }
      .bottom {
        cursor: pointer;
      }
      .bottom:hover .bottom-text {
        color: #f59a23;
      }
    }
  }
}
</style>